import React, {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react'
import LogoBranco from '../../assets/LogoBranco.png'
import apinode from '../../services/apinode'
import { Dropdown } from 'react-bootstrap'

import {
  Banknote,
  BarChart3,
  Box,
  ChevronDown,
  DollarSign,
  FileText,
  HelpCircle,
  Menu,
  MessageCircle,
  Moon,
  Package,
  Power,
  Sun,
  Truck,
  X,
} from 'lucide-react'
import { useNavigate } from 'react-router-dom'

// Certifique-se de ter no index.js/App.js:
// import 'bootstrap/dist/css/bootstrap.min.css'

/* ==========================
   Helpers
   ========================== */

const QuestionsComponent = () => (
  <div
    style={{
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      gap: '4px',
    }}
  >
    <MessageCircle size={18} />
    <span style={{ fontSize: '10px' }}>Perguntas</span>
  </div>
)

const PerguntasPopup = ({ showNotification, totalPerguntas, onClose }) => {
  if (!showNotification) return null
  return (
    <div
      style={{
        position: 'fixed',
        top: '70px',
        right: '20px',
        background: '#fff',
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '15px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        zIndex: 1050,
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span>Você tem {totalPerguntas} pergunta(s)</span>
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: '#666',
          }}
        >
          <X size={16} />
        </button>
      </div>
    </div>
  )
}

const Ask = (message, callback) => {
  if (window.confirm(message)) callback()
}

const AuthContext = React.createContext({ setLogado: () => {} })

/* ==========================
   Dados do Menu
   ========================== */

const menuItems = [
  {
    id: 'menu',
    title: 'Menu',
    icon: <Menu size={18} />,
    subItems: [
      { link: '/bling/listar', text: 'Importar Amazon do Bling' },
      { link: '/produtividade', text: 'Produtividade' },
      { link: '/packlist', text: 'Packlist' },
      { link: '/checkout', text: 'Checkout' },
      { link: '/shopee', text: 'Autenticação Shopee' },
      { link: '/pedidos-compra', text: 'Pedidos de Compra' },
      { link: '/marcas', text: 'Cadastro de Marcas' },
      { link: '/representantes-comerciais', text: 'Representantes Comerciais' },
      { link: '/boletos', text: 'Boletos' },
      { link: '/categorias-subcategorias', text: 'Categorias & Subcategorias' },
      { link: '/orcamentos', text: 'Orçamentos' },
      { link: '/consultar-transferencias', text: 'Consultar Transferências' },
      { link: '/tranferencia-estoque', text: 'Transferência de Estoque' },
      { link: '/consultar-saldo', text: 'Consultar Saldo' },
      { link: '/integracoes', text: 'Integrações' },
      { link: '/importar/pedidos', text: 'Importar Pedidos' },
      { link: '/clientes', text: 'Clientes' },
      { link: '/pedidos/cliente', text: 'Pedidos por Cliente' },
      { link: '/contas-a-receber', text: 'Contas a Receber' },
      { link: '/devolucoes', text: 'Minhas Devoluções' },
      { link: '/reclamacoes', text: 'Reclamações' },
      { link: '/funcionarios', text: 'Funcionários' },
      { link: '/pedidos/marktplaces', text: 'Pedidos' },
      { link: '/inventario', text: 'Inventários' },
      { link: '/contasapagar', text: 'Contas a Pagar' },
      { link: '/mercadolivre/pedidos', text: 'Vendas do Mercado Livre' },
      { link: '/trocas-e-devolucoes', text: 'Trocas e Devoluções' },
      { link: '/expedicao', text: 'Retiradas de mercadoria' },
      { link: '/mercadopago', text: 'Relatórios do Mercado Pago' },
      { link: '/orders_aguardando', text: 'Pedidos aguardando faturamento' },
    ].sort((a, b) => a.text.localeCompare(b.text)),
  },
  {
    id: 'mercadolivre',
    title: 'Mercado Livre',
    icon: <DollarSign size={18} />,
    subItems: [
      { link: '/mercadolivre/anuncios', text: 'Meus Anúncios' },
      { link: '/mercadolivre/pedidos', text: 'Meus Pedidos' },
      { link: '/mercadolivre/prices', text: 'Tira Teima' },
      { link: '/mercadolivre/auth-codes', text: 'Códigos de Autorização' },
      { link: '/mercadolivre/calculo-lucros', text: 'Cálculo Real dos Lucros' },
    ].sort((a, b) => a.text.localeCompare(b.text)),
  },
  {
    id: 'Shopee',
    title: 'Shopee',
    icon: <DollarSign size={18} />,
    subItems: [
      { link: '/shopee/items', text: 'Meus Anúncios' },
      
    ].sort((a, b) => a.text.localeCompare(b.text)),
  },
  {
    id: 'produtos',
    title: 'Produtos',
    icon: <Box size={18} />,
    subItems: [
      { link: '/produtos', text: 'Listar Produtos' },
      { link: '/ajuste-estoque', text: 'Ajuste de Estoque' },
      { link: '/produtos/importar/bling', text: 'Importar Produtos do Bling' },
      { link: '/produtos/novo', text: 'Cadastrar Produto' },
      { link: '/importar-produtos', text: 'Importar Produtos da Matriz' },
      { link: '/produtos/centrodecustos', text: 'Centro de Custos' },
      { link: '/consultar-heranca', text: 'Consultar Herança de Produtos' },
      { link: '/produtos/importarEstoque', text: 'Importar custos do Bling' },
      { link: '/itens', text: 'Produtos por pedido' },
      { link: '/armazens-virtuais', text: 'Armazens virtuais' },
      { link: '/produtos/ajuste-composicao', text: 'Ajuste de Composição' },
    ].sort((a, b) => a.text.localeCompare(b.text)),
  },
  {
    id: 'relatorios',
    title: 'Relatórios',
    icon: <BarChart3 size={18} />,
    subItems: [
      { link: '/produtos/reserva', text: 'Relatórios de Reserva' },
      {
        link: '/relatorios/sem_movimentacoes',
        text: 'Relatório de produtos sem movimentação',
      },
      { link: '/produtos/estoque-minimo', text: 'Relatório de Estoque Mínimo' },
      { link: '/relatorios/vendedor', text: 'Relatório por vendedor' },
      { link: '/rt', text: 'Relatórios de Rt' },
      { link: '/relatorios/produtos/relprodutos', text: 'Custo x Venda' },
      { link: '/anuncios/log', text: 'Log de anuncios' },
      { link: '/relatorios/compras', text: 'Compras e estoque' },
      { link: '/relatorios/separacao-por-data', text: 'Separação por Data' },
      { link: '/relatorios/relatorio-vendas', text: 'Itens vendidos' },
      {
        link: '/relatorios/comissoes-representante',
        text: 'Comissões por Representante',
      },
    ].sort((a, b) => a.text.localeCompare(b.text)),
  },
  {
    id: 'financeiro',
    title: 'Financeiro',
    icon: <Banknote size={18} />,
    subItems: [{ link: '/relatorio/faturamento', text: 'Faturamento' }],
  },
  {
    id: 'leroymerlin',
    title: 'Leroy Merlin',
    icon: <Package size={18} />,
    subItems: [
      { link: '/leroymerlin/importar/pedidos', text: 'Importar Pedidos' },
    ],
  },
  {
    id: 'nfe',
    title: 'Nfe',
    icon: <FileText size={18} />,
    subItems: [{ link: '/listagem/nfe', text: 'Nfes' }],
  },
  {
    id: 'wms',
    title: 'WMS',
    icon: <Truck size={18} />,
    subItems: [
      { link: '/wms/separacao', text: 'Separação por Onda' },
      { link: '/lista/nfe-entrada', text: 'Listar Nfe Entrada' },
      { link: '/bling/nfe', text: 'Importar Nfe' },
      { link: '/wms/os', text: 'O.S' },
      { link: '/wms/bonus', text: 'Bônus' },
      { link: '/wms/enderecos', text: 'Endereços' },
      { link: '/wms/tranferencia-endereco', text: 'Transferência de Endereço' },
      { link: '/wms/tranferencia-picking', text: 'Transferência de Picking' },
      { link: '/wms/motivos', text: 'Motivos' },
      { link: '/wms/codoper-tipoos', text: 'Cód. Oper. & Tipo OS' },
      { link: '/wms/embalagens', text: 'Embalagens' },
      { link: '/wms/ajustar/enderecos', text: 'Ajus. Estoque End.' },
      { link: '/wms/produtos', text: 'Produtos' },
      { link: '/wms/inventarios', text: 'Inventários' },
      { link: '/wms/relatorios', text: 'Relatórios' },
    ].sort((a, b) => a.text.localeCompare(b.text)),
  },
]

/* ==========================
   Grupos do Menu Caixa
   ========================== */

const caixaGroups = [
  {
    label: 'Abrir / Consultar',
    items: [
      { link: '/caixa/abertura', text: 'Abrir Caixa' },
      { link: '/caixa/diario', text: 'Consultar Caixa (Diário)' },
    ],
  },
  {
    label: 'Ajustes',
    items: [
      { link: '/caixa/ajustes', text: 'Ajustes de Caixa' },
      { link: '/caixa/sangria', text: 'Sangria' },
      { link: '/caixa/suprimento', text: 'Suprimento' },
    ],
  },
]

/* ==========================
   Estilos dinâmicos por tema
   ========================== */

const getStyles = (isDark) => ({
  loggedInParagraph: { all: 'unset', fontSize: 10, fontWeight: 'bold' },
  loggedInSpan: { color: isDark ? '#60a5fa' : '#2563eb', fontWeight: 'bold' },
  navbar: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '60px',
    backgroundColor: isDark ? '#000000' : '#ffffff',
    color: isDark ? '#fff' : '#111',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 1rem',
    boxShadow: isDark
      ? '0 2px 8px rgba(0,0,0,0.6)'
      : '0 2px 8px rgba(0,0,0,0.12)',
    borderBottom: isDark ? '1px solid #222' : '1px solid #e5e7eb',
    transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  logo: { width: '50px', height: '50px', marginRight: '8px' },
  mobileToggle: {
    background: 'none',
    border: 'none',
    color: isDark ? '#fff' : '#111',
    cursor: 'pointer',
  },
  navContent: { display: 'flex', alignItems: 'center', gap: '0.2rem' },
  navContentMobile: {
    position: 'fixed',
    top: '60px',
    left: 0,
    right: 0,
    backgroundColor: isDark ? '#000' : '#fff',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '1rem 0.5rem',
    maxHeight: 'calc(100vh - 60px)',
    overflowY: 'auto',
  },
  dropdown: { position: 'relative' },
  dropdownButton: {
    background: 'none',
    border: 'none',
    color: isDark ? '#fff' : '#111',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px',
    padding: '0.2rem 0.4rem',
    fontSize: '10px',
    whiteSpace: 'nowrap',
    borderRadius: '4px',
    transition: 'background-color 0.2s',
  },
  dropdownMenu: {
    position: 'absolute',
    top: '100%',
    left: 0,
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '4px',
    minWidth: '220px',
    maxHeight: '400px',
    overflowY: 'auto',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    zIndex: 1001,
  },
  dropdownMenuMobile: {
    position: 'static',
    backgroundColor: 'rgba(255,255,255,0.1)',
    border: 'none',
    borderRadius: '4px',
    width: '100%',
    marginTop: '0.2rem',
    marginLeft: '1rem',
  },
  dropdownItem: {
    display: 'block',
    padding: '0.5rem 0.75rem',
    color: '#333',
    textDecoration: 'none',
    borderBottom: '1px solid #f0f0f0',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'background-color 0.2s',
    width: '100%',
    textAlign: 'left',
    background: 'transparent',
  },
  dropdownItemMobile: {
    color: '#fff',
    borderBottom: '1px solid rgba(255,255,255,0.1)',
  },
  navLink: {
    color: isDark ? '#fff' : '#111',
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px',
    padding: '0.2rem 0.4rem',
    fontSize: '10px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    borderRadius: '4px',
    transition: 'background-color 0.2s',
  },
  powerButton: {
    fontSize: '10px',
    background: 'none',
    border: 'none',
    color: isDark ? '#fff' : '#111',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px',
    padding: '0.2rem 0.4rem',
    borderRadius: '4px',
    transition: 'background-color 0.2s',
  },
  themeToggle: {
    fontSize: '10px',
    background: 'none',
    border: 'none',
    color: isDark ? '#fff' : '#111',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px',
    padding: '0.2rem 0.4rem',
    borderRadius: '4px',
    transition: 'background-color 0.2s, color 0.3s',
  },
})

/* ==========================
   Dropdown genérico (subItems simples)
   ========================== */

const MenuDropdown = ({
  item,
  onSelect,
  isMobile,
  isDropdownOpen,
  toggleDropdown,
  styles,
}) => {
  const handleLinkClick = (link) => {
    onSelect(link)
    toggleDropdown(null)
  }

  const dropdownProps = isMobile
    ? { onClick: () => toggleDropdown(isDropdownOpen ? null : item.id) }
    : {
        onMouseEnter: () => toggleDropdown(item.id),
        onMouseLeave: () => toggleDropdown(null),
      }

  return (
    <div
      style={styles.dropdown}
      {...(isMobile ? {} : dropdownProps)}
    >
      <button
        style={styles.dropdownButton}
        onClick={isMobile ? dropdownProps.onClick : undefined}
      >
        {item.icon}
        {item.title}
        <ChevronDown
          size={12}
          style={{
            transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
          }}
        />
      </button>

      {isDropdownOpen && (
        <div
          style={
            isMobile
              ? { ...styles.dropdownMenu, ...styles.dropdownMenuMobile }
              : styles.dropdownMenu
          }
        >
          {item.subItems.map((subItem, index) => (
            <a
              key={index}
              href={subItem.link}
              style={
                isMobile
                  ? { ...styles.dropdownItem, ...styles.dropdownItemMobile }
                  : styles.dropdownItem
              }
              onClick={(e) => {
                e.preventDefault()
                handleLinkClick(subItem.link)
              }}
            >
              {subItem.text}
            </a>
          ))}

          {item.id === 'menu' && (
            <>
              <div
                style={{
                  borderTop: isMobile
                    ? '1px solid rgba(255,255,255,0.2)'
                    : '1px solid #ddd',
                  margin: '0.5rem 0',
                }}
              />
              <button
                type="button"
                style={
                  isMobile
                    ? { ...styles.dropdownItem, ...styles.dropdownItemMobile }
                    : styles.dropdownItem
                }
                onMouseDown={() =>
                  Ask('Deseja sair do sistema?', () => onSelect('/login'))
                }
              >
                Sair
              </button>
            </>
          )}
        </div>
      )}
    </div>
  )
}

/* ==========================
   CaixaDropdown — Bootstrap
   ========================== */

const CaixaDropdown = ({ onSelect, isDark, styles }) => {
  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="link"
        id="dropdown-caixa"
        style={{
          ...styles.dropdownButton,
          textDecoration: 'none',
          boxShadow: 'none',
          color: isDark ? '#fff' : '#111',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Banknote size={18} />
        Menu Caixa
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{
          minWidth: '230px',
          maxHeight: '400px',
          overflowY: 'auto',
          borderRadius: '6px',
          boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
          border: '1px solid #e5e7eb',
          padding: '0.4rem 0',
        }}
      >
        {caixaGroups.map((group, gi) => (
          <React.Fragment key={gi}>
            {gi > 0 && <Dropdown.Divider style={{ margin: '0.3rem 0' }} />}

            {/* Cabeçalho do grupo */}
            <Dropdown.Header
              style={{
                fontSize: '10px',
                fontWeight: '700',
                color: '#6b7280',
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
                padding: '0.5rem 1rem 0.25rem',
                userSelect: 'none',
              }}
            >
              {group.label}
            </Dropdown.Header>

            {group.items.map((item, ii) => (
              <Dropdown.Item
                key={ii}
                href={item.link}
                style={{
                  fontSize: '13.5px',
                  padding: '0.45rem 1.2rem',
                  color: '#1f2937',
                  transition: 'background 0.15s',
                }}
                onClick={(e) => {
                  e.preventDefault()
                  onSelect(item.link)
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = '#f3f4f6')
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = 'transparent')
                }
              >
                {item.text}
              </Dropdown.Item>
            ))}
          </React.Fragment>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

/* ==========================
   Sidebar (Topbar) principal
   ========================== */

const Sidebar = forwardRef((props, ref) => {
  const [totalPerguntas, setTotalPerguntas] = useState(0)
  const [showNotification, setShowNotification] = useState(false)
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [openDropdownId, setOpenDropdownId] = useState(null)
  const [isDark, setIsDark] = useState(true) // começa no modo escuro (preto)

  const { setLogado } = useContext(AuthContext) || { setLogado: () => {} }
  const navigate = useNavigate()
  const styles = getStyles(isDark)

  const idconta =
    typeof localStorage !== 'undefined' ? localStorage.idconta || '123' : '123'

  const toggleDropdown = (id) =>
    setOpenDropdownId(id === openDropdownId ? null : id)

  const handleLinkClick = useCallback(
    (link) => {
      navigate(link)
      setIsMobileMenuOpen(false)
      setOpenDropdownId(null)
    },
    [navigate],
  )

  const logOut = useCallback(() => {
    setLogado(false)
    handleLinkClick('/login')
    localStorage.clear()
  }, [handleLinkClick, setLogado])

  const fetchPerguntas = useCallback(async () => {
    try {
      const response = await apinode.get(`/mercadolivreperguntas/${idconta}`)
      const total = response.data.totais
      if (total > 0) {
        setShowNotification(true)
        setTotalPerguntas(total)
      }
    } catch (error) {
      console.error('Erro ao buscar os dados:', error)
    }
  }, [idconta])

  useEffect(() => {
    fetchPerguntas()
  }, [fetchPerguntas])

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768)
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return (
    <>
      <nav
        ref={ref}
        style={styles.navbar}
      >
        {/* Logo */}
        <a
          style={styles.brand}
          onClick={() => handleLinkClick('/')}
        >
          <img
            src={LogoBranco}
            style={styles.logo}
            alt="Logo"
          />
        </a>

        {/* Usuário logado */}
        <p style={styles.loggedInParagraph}>
          <span style={styles.loggedInSpan}>{localStorage.username}</span>
          {' EM '}
          <span style={styles.loggedInSpan}>
            {localStorage.nomeconta} ({localStorage.idconta})
          </span>
        </p>

        {/* Botão hambúrguer (mobile) */}
        {isMobile && (
          <button
            style={styles.mobileToggle}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Abrir/Fechar menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        )}

        {/* Itens de navegação */}
        <div
          style={{
            ...styles.navContent,
            ...(isMobile && isMobileMenuOpen ? styles.navContentMobile : {}),
            display: isMobile ? (isMobileMenuOpen ? 'flex' : 'none') : 'flex',
          }}
        >
          {/* Menus genéricos */}
          {menuItems.map((item) => (
            <MenuDropdown
              key={item.id}
              item={item}
              onSelect={handleLinkClick}
              isMobile={isMobile}
              isDropdownOpen={openDropdownId === item.id}
              toggleDropdown={toggleDropdown}
              styles={styles}
            />
          ))}

          {/* ✅ Menu Caixa — Bootstrap Dropdown com grupos */}
          <CaixaDropdown
            onSelect={handleLinkClick}
            isDark={isDark}
            styles={styles}
          />

          {/* FAQ */}
          <a
            style={styles.navLink}
            onClick={() => handleLinkClick('/faq')}
          >
            <HelpCircle size={18} />
            Me Ajude
          </a>

          {/* Perguntas */}
          <a
            style={styles.navLink}
            onClick={() => handleLinkClick('/perguntas')}
          >
            <QuestionsComponent />
          </a>

          {/* ✅ Toggle Dark / Light */}
          <button
            style={styles.themeToggle}
            onClick={() => setIsDark((prev) => !prev)}
            title={isDark ? 'Mudar para modo claro' : 'Mudar para modo escuro'}
          >
            {isDark ? <Sun size={18} /> : <Moon size={18} />}
            {isDark ? 'Claro' : 'Escuro'}
          </button>

          {/* Sair */}
          <button
            style={styles.powerButton}
            onClick={() => Ask('Deseja sair do sistema?', logOut)}
          >
            <Power size={18} />
            Sair
          </button>
        </div>
      </nav>

      <PerguntasPopup
        showNotification={showNotification}
        totalPerguntas={totalPerguntas}
        onClose={() => setShowNotification(false)}
      />

      {/* Espaçador abaixo da barra fixa */}
      <div style={{ height: '60px' }} />
    </>
  )
})

export default Sidebar
